import {STATUS_RESOURCE} from 'config/constants/infrastructureResources';

import {resourceTypesIcons} from 'modules/store/resourceTypes';
import {getAccountColor} from 'modules/store/accounts';

import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';

import {TIMESTAMP_MULTIPLY, PERCENT, DEFAULT_VALUE, TIMEOUT_STORE} from 'util/constants';

const MAX_TRIES = 20;

const transformEntitiesFn = item => {
    const accountName = item.account.name;

    return {
        id:                  item.id,
        resourceId:          item.resource_id || item.title,
        title:               item.title || item.resource_id,
        subtitle:            item.resource_id,
        vendor:              item.vendor,
        vendorIcon:          item.vendor.code.toLowerCase(),
        vendorName:          item.vendor.title,
        resourceType:        item.resource_type.code,
        resourceTypeName:    item.resource_type.title,
        resourceTypeIcon:    resourceTypesIcons[item.resource_type.code],
        productName:         item.product.title,
        group:               item.group && item.group.title,
        region:              item.region && item.region.code,
        regionTooltip:       item.region && item.region.title,
        instanceType:        item.instance_type,
        account:             item.account,
        accountName,
        accountColor:        getAccountColor(accountName),
        services:            item.services,
        status:              item.status.code,
        msp:                 item.account.msp,
        networks:            item.networks || [],
        volumes:             item.volumes || [],
        internetConnections: item.internetConnections ? {
            ips: [],
            ...item.internetConnections
        } : {ips: []}
    };
};

const UPDATING_ACTIONS = {
    RESOURCES_START_SUCCESS: 'start',
    RESOURCES_STOP_SUCCESS:  'stop'
};
const _callbackStartStop = (state, action) => ({
    ...state,
    isUpdating:    true,
    didInvalidate: false,
    error:         null,
    lastAction:    ''
});
const _callbackStartStopSuccess = (state, action) => {

    const
        newEntity = action.entity || action.entities,
        newResource = transformEntitiesFn(newEntity),
        newState = {
            ...state,
            isUpdating: false,
            lastAction: UPDATING_ACTIONS[action.type]
        };
    let changed = false;

    Object.keys(state.cache.entities).forEach(key => {
        const
            entities = state.cache.entities[key].data.slice(),
            resourceIndex = entities.findIndex(_resource => _resource.id === newResource.id);

        if (~resourceIndex) {
            if (newResource.status !== entities[resourceIndex].status) {
                changed = true;
                entities[resourceIndex] = newResource;
                newState.cache.entities = {
                    ...state.cache.entities,
                    [key]: {
                        ...state.cache.entities[key],
                        data: entities
                    }
                };
            }
        }
    });

    const entity = state.cache.entity[newResource.id];

    if (entity && entity.data) {
        const resource = {...entity.data};

        if (newResource.status !== resource.status) {
            changed = true;
            resource.status = newResource.status;

            newState.cache.entity = {
                ...state.cache.entity,
                [resource.id]: {
                    ...state.cache.entity[resource.id],
                    data: newResource
                }
            };
        }
    }

    if (changed) {
        newState.stillTryingRefresh = {
            ...newState.stillTryingRefresh,
            [newResource.id]: DEFAULT_VALUE
        };

        return newState;
    }

    if (newResource.status === STATUS_RESOURCE.STATUS_RESOURCE_PENDING) {
        if (!newState.stillTryingRefresh[newResource.id]) {
            newState.stillTryingRefresh = {
                [newResource.id]: DEFAULT_VALUE
            };
        }
        if (newState.stillTryingRefresh[newResource.id] < MAX_TRIES) {
            newState.stillTryingRefresh = {
                [newResource.id]: ++newState.stillTryingRefresh[newResource.id]
            };
        } else {
            return _callbackStartStopSuccess(state, {
                ...action,
                entity: {
                    ...newEntity,
                    status: {code: STATUS_RESOURCE.STATUS_RESOURCE_WARNING}
                }
            });
        }
    }

    return newState;
};
const _createFetchParams = (filters, pagination, sortBy) =>
    ({...filters,
        ...pagination,
        ordering: sortBy
    });

module.exports = {
    createFetchParams: _createFetchParams,
    ...storeModuleFactory({
        name:             'resourcesModal',
        endpoint:         endpoints.resources.endpoint,
        instanceEndpoint: endpoints.resources.instanceEndpoint,
        timeout:          TIMEOUT_STORE.TIMEOUT_STORE_MEDIUM,
        extraState:       {
            installed:            [],
            isFetchingInstalled:  false,
            associated:           [],
            isFetchingAssociated: false,
            discoveryResponse:    null,
            stillTryingRefresh:   {},
            cpuLoad:              {},
            isFetchingLogs:       false,
            operationLogs:        [],
            operationLogsTotal:   DEFAULT_VALUE
        },
        sortParamsMap: {
            vendorIcon:   'vendor',
            instanceType: 'instance_type'
        },
        transformEntitiesFn,
        extraActions: [{
            method:  'fetch',
            action:  'darkFetch',
            url:     endpoints.resources.instanceEndpoint,
            start:   state => state,
            success: _callbackStartStopSuccess
        }, {
            method:  'update',
            action:  'start',
            url:     endpoints.resources.extraActionsUpdateStartEndpoint,
            start:   _callbackStartStop,
            success: _callbackStartStopSuccess
        }, {
            method:  'update',
            action:  'stop',
            url:     endpoints.resources.extraActionsUpdateStopEndpoint,
            start:   _callbackStartStop,
            success: _callbackStartStopSuccess
        }, {
            method:  'create',
            action:  'discover',
            url:     endpoints.resources.extraActionsCreateServiceDiscoveryEndpoint,
            start:   state => state,
            success: (state, action) => ({
                ...state,
                discoveryResponse: action.data
            })
        }, {
            method: 'fetch',
            action: 'fetchCpuLoad',
            url:    endpoints.resources.extraActionsInfrastructureOperations,
            start:  (state, action) => ({
                ...state,
                cpuLoad: {
                    ...state.cpuLoad,
                    [action.id]: {
                        isFetching: true
                    }
                }
            }),
            success: (state, action) => {
                const _cpuLoad = action.entities.map(item => ({
                    ...item,
                    timestamp: item.timestamp * TIMESTAMP_MULTIPLY,
                    average:   item.average / PERCENT
                }));

                return {
                    ...state,
                    cpuLoad: {
                        ...state.cpuLoad,
                        [action.id]: {
                            isFetching: false,
                            data:       _cpuLoad
                        }
                    }
                };
            }
        }]
    })};



// WEBPACK FOOTER //
// ./src/modules/store/resourcesModal.js